// AUTO-GENERATED by modules/searchManifest.ts — do not edit.
export interface SearchManifestEntry {
  pagePath: string
  pageTitle: string
  pageIcon?: string
  sectionId?: string
  sectionLabel?: string
  fieldLabel?: string
  fieldInfo?: string
  kind: 'page' | 'section' | 'field'
}

export const searchManifest: SearchManifestEntry[] = [
  {
    "pagePath": "/account/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:user-cog",
    "kind": "page"
  },
  {
    "pagePath": "/account/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:user-cog",
    "sectionId": "plan",
    "sectionLabel": "components.account.pages.planAndBilling.label",
    "kind": "section"
  },
  {
    "pagePath": "/account/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:user-cog",
    "sectionId": "transactions",
    "sectionLabel": "components.account.elements.billing.taxInvoices",
    "kind": "section"
  },
  {
    "pagePath": "/account/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:user-cog",
    "sectionId": "referral",
    "sectionLabel": "components.account.pages.referral.label",
    "kind": "section"
  },
  {
    "pagePath": "/account/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:user-cog",
    "sectionId": "existingReferrals",
    "sectionLabel": "pages.account.index.referral.existingReferrals",
    "kind": "section"
  },
  {
    "pagePath": "/account/security-and-legal",
    "pageTitle": "manage.pages.securityAndLegal",
    "pageIcon": "lucide:shield",
    "kind": "page"
  },
  {
    "pagePath": "/account/security-and-legal/security",
    "pageTitle": "components.account.pages.security.label",
    "pageIcon": "lucide:shield",
    "kind": "page"
  },
  {
    "pagePath": "/account/security-and-legal/security",
    "pageTitle": "components.account.pages.security.label",
    "pageIcon": "lucide:shield",
    "sectionId": "app",
    "sectionLabel": "pages.account.index.security.app",
    "kind": "section"
  },
  {
    "pagePath": "/account/security-and-legal/security",
    "pageTitle": "components.account.pages.security.label",
    "pageIcon": "lucide:shield",
    "sectionId": "app",
    "sectionLabel": "pages.account.index.security.app",
    "fieldLabel": "pages.account.index.security.app",
    "fieldInfo": "pages.account.index.security.appInfo",
    "kind": "field"
  },
  {
    "pagePath": "/account/security-and-legal/security",
    "pageTitle": "components.account.pages.security.label",
    "pageIcon": "lucide:shield",
    "sectionId": "app",
    "sectionLabel": "pages.account.index.security.app",
    "fieldLabel": "pages.account.index.security.appTimeout",
    "fieldInfo": "pages.account.index.security.appTimeoutInfo",
    "kind": "field"
  },
  {
    "pagePath": "/account/security-and-legal/security",
    "pageTitle": "components.account.pages.security.label",
    "pageIcon": "lucide:shield",
    "sectionId": "web",
    "sectionLabel": "pages.account.index.security.web",
    "kind": "section"
  },
  {
    "pagePath": "/account/security-and-legal/security",
    "pageTitle": "components.account.pages.security.label",
    "pageIcon": "lucide:shield",
    "sectionId": "web",
    "sectionLabel": "pages.account.index.security.web",
    "fieldLabel": "pages.account.index.security.web",
    "fieldInfo": "pages.account.index.security.webInfo",
    "kind": "field"
  },
  {
    "pagePath": "/account/security-and-legal/security",
    "pageTitle": "components.account.pages.security.label",
    "pageIcon": "lucide:shield",
    "sectionId": "web",
    "sectionLabel": "pages.account.index.security.web",
    "fieldLabel": "pages.account.index.security.webTimeout",
    "fieldInfo": "pages.account.index.security.webTimeoutInfo",
    "kind": "field"
  },
  {
    "pagePath": "/account/security-and-legal/security",
    "pageTitle": "components.account.pages.security.label",
    "pageIcon": "lucide:shield",
    "sectionId": "ipRestrictions",
    "sectionLabel": "pages.account.index.security.restrict",
    "kind": "section"
  },
  {
    "pagePath": "/account/security-and-legal/security",
    "pageTitle": "components.account.pages.security.label",
    "pageIcon": "lucide:shield",
    "sectionId": "ipRestrictions",
    "sectionLabel": "pages.account.index.security.restrict",
    "fieldLabel": "pages.account.index.security.restrict",
    "fieldInfo": "pages.account.index.security.restrictInfo",
    "kind": "field"
  },
  {
    "pagePath": "/account/security-and-legal/security",
    "pageTitle": "components.account.pages.security.label",
    "pageIcon": "lucide:shield",
    "sectionId": "ipRestrictions",
    "sectionLabel": "pages.account.index.security.restrict",
    "fieldLabel": "pages.account.index.security.employeeBlacklist",
    "fieldInfo": "pages.account.index.security.employeeBlacklistInfo",
    "kind": "field"
  },
  {
    "pagePath": "/account/security-and-legal/security",
    "pageTitle": "components.account.pages.security.label",
    "pageIcon": "lucide:shield",
    "sectionId": "ipRestrictions",
    "sectionLabel": "pages.account.index.security.restrict",
    "fieldLabel": "pages.account.index.security.onlineBlacklist",
    "fieldInfo": "pages.account.index.security.onlineBlacklistInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:building-2",
    "kind": "page"
  },
  {
    "pagePath": "/manage/business/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:building-2",
    "sectionId": "fields",
    "fieldLabel": "general.businessName",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:building-2",
    "sectionId": "fields",
    "fieldLabel": "general.email",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:building-2",
    "sectionId": "fields",
    "fieldLabel": "general.phone",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:building-2",
    "sectionId": "fields",
    "fieldLabel": "pages.manage.index.location.timeZone",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:building-2",
    "sectionId": "fields",
    "fieldLabel": "pages.manage.index.location.locale",
    "fieldInfo": "pages.manage.index.location.localeInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:building-2",
    "sectionId": "fields",
    "fieldLabel": "general.currencySymbol",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:building-2",
    "sectionId": "fields",
    "fieldLabel": "general.customerNameFormat",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/account",
    "pageTitle": "general.account",
    "pageIcon": "lucide:building-2",
    "sectionId": "fields",
    "fieldLabel": "general.theme",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/address",
    "pageTitle": "general.address",
    "pageIcon": "lucide:map-pin",
    "kind": "page"
  },
  {
    "pagePath": "/manage/business/address",
    "pageTitle": "general.address",
    "pageIcon": "lucide:map-pin",
    "sectionId": "fields",
    "fieldLabel": "general.address",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/address",
    "pageTitle": "general.address",
    "pageIcon": "lucide:map-pin",
    "sectionId": "fields",
    "fieldLabel": "general.city",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/address",
    "pageTitle": "general.address",
    "pageIcon": "lucide:map-pin",
    "sectionId": "fields",
    "fieldLabel": "general.region",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/address",
    "pageTitle": "general.address",
    "pageIcon": "lucide:map-pin",
    "sectionId": "fields",
    "fieldLabel": "general.postcode",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/address",
    "pageTitle": "general.address",
    "pageIcon": "lucide:map-pin",
    "sectionId": "fields",
    "fieldLabel": "general.country",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business",
    "pageTitle": "manage.pages.business",
    "pageIcon": "lucide:briefcase",
    "kind": "page"
  },
  {
    "pagePath": "/manage/business/notes",
    "pageTitle": "manage.landings.business.notesLabel",
    "pageIcon": "lucide:notebook-pen",
    "kind": "page"
  },
  {
    "pagePath": "/manage/business/notes",
    "pageTitle": "manage.landings.business.notesLabel",
    "pageIcon": "lucide:notebook-pen",
    "sectionId": "fields",
    "fieldLabel": "pages.manage.index.location.notesFormula",
    "fieldInfo": "pages.manage.index.location.customerNotesTemplate",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/schedule",
    "pageTitle": "general.schedule",
    "pageIcon": "lucide:calendar-clock",
    "kind": "page"
  },
  {
    "pagePath": "/manage/business/schedule",
    "pageTitle": "general.schedule",
    "pageIcon": "lucide:calendar-clock",
    "sectionId": "fields",
    "fieldLabel": "pages.manage.index.schedule.weekStart",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/schedule",
    "pageTitle": "general.schedule",
    "pageIcon": "lucide:calendar-clock",
    "sectionId": "fields",
    "fieldLabel": "pages.manage.index.schedule.timeFormat",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/schedule",
    "pageTitle": "general.schedule",
    "pageIcon": "lucide:calendar-clock",
    "sectionId": "fields",
    "fieldLabel": "pages.manage.index.schedule.slotSize",
    "fieldInfo": "pages.manage.index.schedule.slotSizeInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/schedule",
    "pageTitle": "general.schedule",
    "pageIcon": "lucide:calendar-clock",
    "sectionId": "fields",
    "fieldLabel": "pages.manage.index.schedule.displaySize",
    "fieldInfo": "pages.manage.index.schedule.displaySizeInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/schedule",
    "pageTitle": "general.schedule",
    "pageIcon": "lucide:calendar-clock",
    "sectionId": "fields",
    "fieldLabel": "pages.manage.index.schedule.appointmentRate",
    "fieldInfo": "pages.manage.index.schedule.appointmentRateInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/schedule",
    "pageTitle": "general.schedule",
    "pageIcon": "lucide:calendar-clock",
    "sectionId": "fields",
    "fieldLabel": "pages.manage.index.schedule.prices",
    "fieldInfo": "pages.manage.index.schedule.pricesInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/business/schedule",
    "pageTitle": "general.schedule",
    "pageIcon": "lucide:calendar-clock",
    "sectionId": "fields",
    "fieldLabel": "pages.manage.index.schedule.timeLine",
    "fieldInfo": "pages.manage.index.schedule.timeLineInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/email",
    "pageTitle": "general.email",
    "pageIcon": "lucide:mail",
    "kind": "page"
  },
  {
    "pagePath": "/manage/communications/email",
    "pageTitle": "general.email",
    "pageIcon": "lucide:mail",
    "sectionId": "general",
    "fieldLabel": "pages.manage.index.email.masterTemplate",
    "fieldInfo": "pages.manage.index.email.masterTemplateInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/email",
    "pageTitle": "general.email",
    "pageIcon": "lucide:mail",
    "sectionId": "general",
    "fieldLabel": "pages.manage.index.email.passbook",
    "fieldInfo": "pages.manage.index.email.passbookInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/email",
    "pageTitle": "general.email",
    "pageIcon": "lucide:mail",
    "sectionId": "general",
    "fieldLabel": "pages.manage.index.email.gmail",
    "fieldInfo": "pages.manage.index.email.gmailInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/email",
    "pageTitle": "general.email",
    "pageIcon": "lucide:mail",
    "sectionId": "internal",
    "sectionLabel": "pages.manage.index.email.internalEmailDefaults",
    "kind": "section"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "kind": "page"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "sectionId": "appointment",
    "fieldLabel": "pages.manage.index.reminders.time",
    "fieldInfo": "pages.manage.index.reminders.timeInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "sectionId": "appointment",
    "fieldLabel": "pages.manage.index.reminders.confirmations",
    "fieldInfo": "pages.manage.index.reminders.confirmationsInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "sectionId": "appointment",
    "fieldLabel": "pages.manage.index.reminders.email",
    "fieldInfo": "pages.manage.index.reminders.emailInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "sectionId": "appointment",
    "fieldLabel": "pages.manage.index.reminders.sms",
    "fieldInfo": "pages.manage.index.reminders.smsInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "sectionId": "appointment",
    "fieldLabel": "pages.manage.index.reminders.smsMessage",
    "fieldInfo": "pages.manage.index.reminders.smsMessageInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "sectionId": "review",
    "sectionLabel": "pages.manage.index.reminders.review",
    "kind": "section"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "sectionId": "review",
    "sectionLabel": "pages.manage.index.reminders.review",
    "fieldLabel": "pages.manage.index.reminders.review",
    "fieldInfo": "pages.manage.index.reminders.reviewInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "sectionId": "review",
    "sectionLabel": "pages.manage.index.reminders.review",
    "fieldLabel": "pages.manage.index.reminders.reviewTime",
    "fieldInfo": "pages.manage.index.reminders.reviewTimeInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "sectionId": "review",
    "sectionLabel": "pages.manage.index.reminders.review",
    "fieldLabel": "pages.manage.index.reminders.reviewAlertEmployees",
    "fieldInfo": "pages.manage.index.reminders.reviewAlertEmployeesInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "sectionId": "birthday",
    "sectionLabel": "pages.manage.index.reminders.birthday",
    "kind": "section"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "sectionId": "birthday",
    "sectionLabel": "pages.manage.index.reminders.birthday",
    "fieldLabel": "pages.manage.index.reminders.birthday",
    "fieldInfo": "pages.manage.index.reminders.birthdayInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/reminders",
    "pageTitle": "pages.manage.index.reminders.title",
    "pageIcon": "lucide:bell",
    "sectionId": "birthday",
    "sectionLabel": "pages.manage.index.reminders.birthday",
    "fieldLabel": "pages.manage.index.reminders.birthdayTime",
    "fieldInfo": "pages.manage.index.reminders.birthdayTimeInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/sms",
    "pageTitle": "pages.manage.index.sms.title",
    "pageIcon": "lucide:smartphone",
    "kind": "page"
  },
  {
    "pagePath": "/manage/communications/sms",
    "pageTitle": "pages.manage.index.sms.title",
    "pageIcon": "lucide:smartphone",
    "sectionId": "number",
    "fieldLabel": "general.country",
    "fieldInfo": "pages.manage.index.sms.country",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/sms",
    "pageTitle": "pages.manage.index.sms.title",
    "pageIcon": "lucide:smartphone",
    "sectionId": "number",
    "fieldLabel": "pages.manage.index.sms.title",
    "fieldInfo": "pages.manage.index.sms.smsInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/sms",
    "pageTitle": "pages.manage.index.sms.title",
    "pageIcon": "lucide:smartphone",
    "sectionId": "number",
    "fieldLabel": "pages.manage.index.sms.from",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/sms",
    "pageTitle": "pages.manage.index.sms.title",
    "pageIcon": "lucide:smartphone",
    "sectionId": "provider",
    "sectionLabel": "pages.manage.index.sms.providerInfo",
    "kind": "section"
  },
  {
    "pagePath": "/manage/communications/sms",
    "pageTitle": "pages.manage.index.sms.title",
    "pageIcon": "lucide:smartphone",
    "sectionId": "provider",
    "sectionLabel": "pages.manage.index.sms.providerInfo",
    "fieldLabel": "pages.manage.index.sms.systemNumbers",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/sms",
    "pageTitle": "pages.manage.index.sms.title",
    "pageIcon": "lucide:smartphone",
    "sectionId": "provider",
    "sectionLabel": "pages.manage.index.sms.providerInfo",
    "fieldLabel": "pages.manage.index.sms.alternativeCode",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/sms",
    "pageTitle": "pages.manage.index.sms.title",
    "pageIcon": "lucide:smartphone",
    "sectionId": "provider",
    "sectionLabel": "pages.manage.index.sms.providerInfo",
    "fieldLabel": "pages.manage.index.sms.numberFormat",
    "kind": "field"
  },
  {
    "pagePath": "/manage/communications/sms",
    "pageTitle": "pages.manage.index.sms.title",
    "pageIcon": "lucide:smartphone",
    "sectionId": "messages",
    "sectionLabel": "pages.manage.index.sms.messages",
    "kind": "section"
  },
  {
    "pagePath": "/manage/custom-fields",
    "pageTitle": "general.customFields",
    "pageIcon": "lucide:list",
    "kind": "page"
  },
  {
    "pagePath": "/manage/loyalty-and-promotions",
    "pageTitle": "manage.pages.loyaltyAndPromotions",
    "pageIcon": "lucide:gift",
    "kind": "page"
  },
  {
    "pagePath": "/manage/loyalty-and-promotions",
    "pageTitle": "manage.pages.loyaltyAndPromotions",
    "pageIcon": "lucide:gift",
    "sectionId": "loyalty",
    "sectionLabel": "manage.landings.loyaltyAndPromotions.loyaltyLabel",
    "kind": "section"
  },
  {
    "pagePath": "/manage/loyalty-and-promotions",
    "pageTitle": "manage.pages.loyaltyAndPromotions",
    "pageIcon": "lucide:gift",
    "sectionId": "loyalty",
    "sectionLabel": "manage.landings.loyaltyAndPromotions.loyaltyLabel",
    "fieldLabel": "general.loyaltyEnabled",
    "fieldInfo": "pages.manage.index.loyaltyProgram.loyaltyEnabled",
    "kind": "field"
  },
  {
    "pagePath": "/manage/loyalty-and-promotions",
    "pageTitle": "manage.pages.loyaltyAndPromotions",
    "pageIcon": "lucide:gift",
    "sectionId": "loyalty",
    "sectionLabel": "manage.landings.loyaltyAndPromotions.loyaltyLabel",
    "fieldLabel": "pages.manage.index.loyaltyProgram.includeTax",
    "fieldInfo": "pages.manage.index.loyaltyProgram.includeTaxInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/loyalty-and-promotions",
    "pageTitle": "manage.pages.loyaltyAndPromotions",
    "pageIcon": "lucide:gift",
    "sectionId": "loyalty",
    "sectionLabel": "manage.landings.loyaltyAndPromotions.loyaltyLabel",
    "fieldLabel": "pages.manage.index.loyaltyProgram.pointsEarned",
    "kind": "field"
  },
  {
    "pagePath": "/manage/loyalty-and-promotions",
    "pageTitle": "manage.pages.loyaltyAndPromotions",
    "pageIcon": "lucide:gift",
    "sectionId": "loyalty",
    "sectionLabel": "manage.landings.loyaltyAndPromotions.loyaltyLabel",
    "fieldLabel": "pages.manage.index.loyaltyProgram.pointsRedeemed",
    "kind": "field"
  },
  {
    "pagePath": "/manage/loyalty-and-promotions",
    "pageTitle": "manage.pages.loyaltyAndPromotions",
    "pageIcon": "lucide:gift",
    "sectionId": "loyalty",
    "sectionLabel": "manage.landings.loyaltyAndPromotions.loyaltyLabel",
    "fieldLabel": "pages.manage.index.loyaltyProgram.reset",
    "fieldInfo": "manage.landings.loyaltyAndPromotions.resetInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/products",
    "pageTitle": "general.products",
    "pageIcon": "lucide:package",
    "kind": "page"
  },
  {
    "pagePath": "/manage/resources",
    "pageTitle": "manage.pages.resources",
    "pageIcon": "lucide:boxes",
    "kind": "page"
  },
  {
    "pagePath": "/manage/sales-setup",
    "pageTitle": "manage.pages.salesSetup",
    "pageIcon": "lucide:credit-card",
    "kind": "page"
  },
  {
    "pagePath": "/manage/sales-setup",
    "pageTitle": "manage.pages.salesSetup",
    "pageIcon": "lucide:credit-card",
    "sectionId": "details",
    "sectionLabel": "general.details",
    "kind": "section"
  },
  {
    "pagePath": "/manage/sales-setup",
    "pageTitle": "manage.pages.salesSetup",
    "pageIcon": "lucide:credit-card",
    "sectionId": "details",
    "sectionLabel": "general.details",
    "fieldLabel": "pages.manage.index.details.orderCreationDate",
    "kind": "field"
  },
  {
    "pagePath": "/manage/sales-setup",
    "pageTitle": "manage.pages.salesSetup",
    "pageIcon": "lucide:credit-card",
    "sectionId": "details",
    "sectionLabel": "general.details",
    "fieldLabel": "pages.manage.index.details.receiptNumberType",
    "fieldInfo": "pages.manage.index.details.adminOnly",
    "kind": "field"
  },
  {
    "pagePath": "/manage/sales-setup",
    "pageTitle": "manage.pages.salesSetup",
    "pageIcon": "lucide:credit-card",
    "sectionId": "details",
    "sectionLabel": "general.details",
    "fieldLabel": "pages.manage.index.details.receiptHeader",
    "kind": "field"
  },
  {
    "pagePath": "/manage/sales-setup",
    "pageTitle": "manage.pages.salesSetup",
    "pageIcon": "lucide:credit-card",
    "sectionId": "details",
    "sectionLabel": "general.details",
    "fieldLabel": "pages.manage.index.details.receiptFooter",
    "kind": "field"
  },
  {
    "pagePath": "/manage/sales-setup",
    "pageTitle": "manage.pages.salesSetup",
    "pageIcon": "lucide:credit-card",
    "sectionId": "details",
    "sectionLabel": "general.details",
    "fieldLabel": "pages.manage.index.details.taxDetails",
    "fieldInfo": "pages.manage.index.details.taxDetailsInfo",
    "kind": "field"
  },
  {
    "pagePath": "/manage/services",
    "pageTitle": "general.services",
    "pageIcon": "lucide:scissors",
    "kind": "page"
  },
  {
    "pagePath": "/manage/team",
    "pageTitle": "manage.pages.team",
    "pageIcon": "lucide:users",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/advanced/domain",
    "pageTitle": "minisite.pages.domain",
    "pageIcon": "lucide:link",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/advanced/domain",
    "pageTitle": "minisite.pages.domain",
    "pageIcon": "lucide:link",
    "sectionId": "request",
    "sectionLabel": "pages.minisite.index.domain.title",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/advanced/domain",
    "pageTitle": "minisite.pages.domain",
    "pageIcon": "lucide:link",
    "sectionId": "request",
    "sectionLabel": "pages.minisite.index.domain.title",
    "fieldLabel": "pages.minisite.index.domain.newDomain",
    "fieldInfo": "pages.minisite.index.domain.newDomainInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/advanced/domain",
    "pageTitle": "minisite.pages.domain",
    "pageIcon": "lucide:link",
    "sectionId": "custom",
    "sectionLabel": "pages.minisite.index.domain.customMinisiteDomain",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/advanced/domain",
    "pageTitle": "minisite.pages.domain",
    "pageIcon": "lucide:link",
    "sectionId": "custom",
    "sectionLabel": "pages.minisite.index.domain.customMinisiteDomain",
    "fieldLabel": "minisite.customDomain",
    "fieldInfo": "pages.minisite.index.domain.customDomainInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/advanced",
    "pageTitle": "minisite.pages.advanced",
    "pageIcon": "lucide:wrench",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/advanced/script",
    "pageTitle": "minisite.pages.script",
    "pageIcon": "lucide:braces",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/advanced/script",
    "pageTitle": "minisite.pages.script",
    "pageIcon": "lucide:braces",
    "sectionId": "script",
    "fieldLabel": "pages.minisite.index.script.javascript",
    "fieldInfo": "pages.minisite.index.script.javascriptInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/advanced/script",
    "pageTitle": "minisite.pages.script",
    "pageIcon": "lucide:braces",
    "sectionId": "script",
    "fieldLabel": "pages.minisite.index.script.html",
    "fieldInfo": "pages.minisite.index.script.htmlInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/advanced/seo",
    "pageTitle": "minisite.pages.seo",
    "pageIcon": "lucide:search",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/advanced/seo",
    "pageTitle": "minisite.pages.seo",
    "pageIcon": "lucide:search",
    "sectionId": "seo",
    "fieldLabel": "pages.minisite.index.seo.show",
    "fieldInfo": "pages.minisite.index.seo.showInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info/hours",
    "pageTitle": "minisite.businessHours",
    "pageIcon": "lucide:clock",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/business-info/hours",
    "pageTitle": "minisite.businessHours",
    "pageIcon": "lucide:clock",
    "sectionId": "header",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.hours.info",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info/hours",
    "pageTitle": "minisite.businessHours",
    "pageIcon": "lucide:clock",
    "sectionId": "roster",
    "sectionLabel": "general.schedule",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/business-info/hours",
    "pageTitle": "minisite.businessHours",
    "pageIcon": "lucide:clock",
    "sectionId": "overrides",
    "sectionLabel": "pages.minisite.index.hours.override",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/business-info/hours",
    "pageTitle": "minisite.businessHours",
    "pageIcon": "lucide:clock",
    "sectionId": "overrides",
    "sectionLabel": "pages.minisite.index.hours.override",
    "fieldLabel": "pages.minisite.index.hours.override",
    "fieldInfo": "pages.minisite.index.hours.overrideInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info/hours",
    "pageTitle": "minisite.businessHours",
    "pageIcon": "lucide:clock",
    "sectionId": "overrides",
    "sectionLabel": "pages.minisite.index.hours.override",
    "fieldLabel": "pages.minisite.index.hours.noUpcomingOverrides",
    "fieldInfo": "pages.minisite.index.hours.overridesInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info/hours",
    "pageTitle": "minisite.businessHours",
    "pageIcon": "lucide:clock",
    "sectionId": "legacy",
    "sectionLabel": "minisite.businessHours",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/business-info/hours",
    "pageTitle": "minisite.businessHours",
    "pageIcon": "lucide:clock",
    "sectionId": "legacy",
    "sectionLabel": "minisite.businessHours",
    "fieldLabel": "pages.minisite.index.hours.improved",
    "fieldInfo": "pages.minisite.index.hours.improvedInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "contact",
    "sectionLabel": "pages.minisite.index.contact.title",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "contact",
    "sectionLabel": "pages.minisite.index.contact.title",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.contact.info",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "contact",
    "sectionLabel": "pages.minisite.index.contact.title",
    "fieldLabel": "pages.minisite.index.contact.name",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "contact",
    "sectionLabel": "pages.minisite.index.contact.title",
    "fieldLabel": "general.businessName",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "contact",
    "sectionLabel": "pages.minisite.index.contact.title",
    "fieldLabel": "general.email",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "contact",
    "sectionLabel": "pages.minisite.index.contact.title",
    "fieldLabel": "general.phone",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "contact",
    "sectionLabel": "pages.minisite.index.contact.title",
    "fieldLabel": "general.website",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "contact",
    "sectionLabel": "pages.minisite.index.contact.title",
    "fieldLabel": "pages.minisite.index.contact.businessDescription",
    "fieldInfo": "pages.minisite.index.contact.businessDescriptionInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "address",
    "sectionLabel": "general.address",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "address",
    "sectionLabel": "general.address",
    "fieldLabel": "pages.minisite.index.contact.streetAddress",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "address",
    "sectionLabel": "general.address",
    "fieldLabel": "general.city",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "address",
    "sectionLabel": "general.address",
    "fieldLabel": "pages.minisite.index.contact.stateRegion",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "address",
    "sectionLabel": "general.address",
    "fieldLabel": "pages.minisite.index.contact.zipPostcode",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "address",
    "sectionLabel": "general.address",
    "fieldLabel": "general.country",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "address",
    "sectionLabel": "general.address",
    "fieldLabel": "pages.minisite.index.contact.showOnMap",
    "fieldInfo": "pages.minisite.index.contact.showOnMapInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "address",
    "sectionLabel": "general.address",
    "fieldLabel": "general.location",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "address",
    "sectionLabel": "general.address",
    "fieldLabel": "pages.minisite.index.contact.latitude",
    "fieldInfo": "pages.minisite.index.contact.manualMapLocation",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info",
    "pageTitle": "minisite.pages.businessInfo",
    "pageIcon": "lucide:building-2",
    "sectionId": "address",
    "sectionLabel": "general.address",
    "fieldLabel": "pages.minisite.index.contact.longitude",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/business-info/social",
    "pageTitle": "minisite.pages.social",
    "pageIcon": "lucide:share-2",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/menu",
    "pageTitle": "minisite.pages.menu",
    "pageIcon": "lucide:menu",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/menu",
    "pageTitle": "minisite.pages.menu",
    "pageIcon": "lucide:menu",
    "sectionId": "mode",
    "fieldLabel": "pages.minisite.index.menu.title",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/minimise-gaps",
    "pageTitle": "pages.minisite.index.minimiseGaps.title",
    "pageIcon": "lucide:minimize-2",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/minimise-gaps",
    "pageTitle": "pages.minisite.index.minimiseGaps.title",
    "pageIcon": "lucide:minimize-2",
    "sectionId": "gaps",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.minimiseGaps.info",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/minimise-gaps",
    "pageTitle": "pages.minisite.index.minimiseGaps.title",
    "pageIcon": "lucide:minimize-2",
    "sectionId": "gaps",
    "fieldLabel": "minimiseGaps.showFirstAvailable",
    "fieldInfo": "pages.minisite.index.minimiseGaps.showAvailableAppointment",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/minimise-gaps",
    "pageTitle": "pages.minisite.index.minimiseGaps.title",
    "pageIcon": "lucide:minimize-2",
    "sectionId": "gaps",
    "fieldLabel": "minimiseGaps.showLastAvailable",
    "fieldInfo": "pages.minisite.index.minimiseGaps.showLastAvailableAppointment",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/minimise-gaps",
    "pageTitle": "pages.minisite.index.minimiseGaps.title",
    "pageIcon": "lucide:minimize-2",
    "sectionId": "gaps",
    "fieldLabel": "pages.minisite.index.minimiseGaps.showAvailabilityImmediately",
    "fieldInfo": "pages.minisite.index.minimiseGaps.showAvailableAppointment",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/minimise-gaps",
    "pageTitle": "pages.minisite.index.minimiseGaps.title",
    "pageIcon": "lucide:minimize-2",
    "sectionId": "gaps",
    "fieldLabel": "minimiseGaps.showAllAvailability",
    "fieldInfo": "pages.minisite.index.minimiseGaps.showAllAvailability",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/minimise-gaps",
    "pageTitle": "pages.minisite.index.minimiseGaps.title",
    "pageIcon": "lucide:minimize-2",
    "sectionId": "gaps",
    "fieldLabel": "minimiseGaps.showAvailabilityLeavingMinGapTime",
    "fieldInfo": "pages.minisite.index.minimiseGaps.showAvailabilityLeavingMinGapTime",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/new-customers",
    "pageTitle": "minisite.newCustomers",
    "pageIcon": "lucide:user-plus",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "sectionId": "book",
    "sectionLabel": "general.onlineBooking",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "sectionId": "book",
    "sectionLabel": "general.onlineBooking",
    "fieldLabel": "general.enabled",
    "fieldInfo": "minisite.onlineBookingInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "sectionId": "book",
    "sectionLabel": "general.onlineBooking",
    "fieldLabel": "pages.minisite.index.booking.bookTabName",
    "fieldInfo": "pages.minisite.index.booking.bookTabNameInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "sectionId": "book",
    "sectionLabel": "general.onlineBooking",
    "fieldLabel": "pages.minisite.index.booking.bookTabInformation",
    "fieldInfo": "pages.minisite.index.booking.bookTabInformationInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "sectionId": "timetable",
    "sectionLabel": "general.timetable",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "sectionId": "timetable",
    "sectionLabel": "general.timetable",
    "fieldLabel": "general.enabled",
    "fieldInfo": "minisite.timetableInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "sectionId": "timetable",
    "sectionLabel": "general.timetable",
    "fieldLabel": "pages.minisite.index.booking.timetableTabName",
    "fieldInfo": "pages.minisite.index.booking.timetableTabNameInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "sectionId": "timetable",
    "sectionLabel": "general.timetable",
    "fieldLabel": "pages.minisite.index.booking.timetableTabInformation",
    "fieldInfo": "pages.minisite.index.booking.timetableTabInformationInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "sectionId": "lastMinute",
    "sectionLabel": "minisite.lastMinute",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "sectionId": "lastMinute",
    "sectionLabel": "minisite.lastMinute",
    "fieldLabel": "general.enabled",
    "fieldInfo": "minisite.lastMinuteInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "sectionId": "lastMinute",
    "sectionLabel": "minisite.lastMinute",
    "fieldLabel": "pages.minisite.index.booking.lastMinuteTabName",
    "fieldInfo": "pages.minisite.index.booking.bookTabNameInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/booking",
    "pageTitle": "general.onlineBooking",
    "pageIcon": "lucide:calendar",
    "sectionId": "lastMinute",
    "sectionLabel": "minisite.lastMinute",
    "fieldLabel": "pages.minisite.index.booking.lastMinuteTabInformation",
    "fieldInfo": "pages.minisite.index.booking.lastMinuteTabInformationInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/courses",
    "pageTitle": "general.courses",
    "pageIcon": "lucide:graduation-cap",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/pages/courses",
    "pageTitle": "general.courses",
    "pageIcon": "lucide:graduation-cap",
    "sectionId": "courses",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.courses.info",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/courses",
    "pageTitle": "general.courses",
    "pageIcon": "lucide:graduation-cap",
    "sectionId": "courses",
    "fieldLabel": "pages.minisite.index.courses.tabName",
    "fieldInfo": "pages.minisite.index.courses.tabNameInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/courses",
    "pageTitle": "general.courses",
    "pageIcon": "lucide:graduation-cap",
    "sectionId": "courses",
    "fieldLabel": "pages.minisite.index.courses.tabInformation",
    "fieldInfo": "pages.minisite.index.courses.tabInformationInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/courses",
    "pageTitle": "general.courses",
    "pageIcon": "lucide:graduation-cap",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/pages/courses",
    "pageTitle": "general.courses",
    "pageIcon": "lucide:graduation-cap",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "fieldLabel": "minisite.termsAgreement",
    "fieldInfo": "pages.minisite.index.courses.termsAgreement",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/courses",
    "pageTitle": "general.courses",
    "pageIcon": "lucide:graduation-cap",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "fieldLabel": "minisite.termsTitle",
    "fieldInfo": "pages.minisite.index.courses.termsTitle",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/courses",
    "pageTitle": "general.courses",
    "pageIcon": "lucide:graduation-cap",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "fieldLabel": "minisite.termsContent",
    "fieldInfo": "pages.minisite.index.courses.termsContent",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/courses",
    "pageTitle": "general.courses",
    "pageIcon": "lucide:graduation-cap",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "fieldLabel": "minisite.termsAccept",
    "fieldInfo": "minisite.termsAcceptInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/customer",
    "pageTitle": "general.customer",
    "pageIcon": "lucide:user",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/pages/customer",
    "pageTitle": "general.customer",
    "pageIcon": "lucide:user",
    "sectionId": "customer",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.customer.info",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/customer",
    "pageTitle": "general.customer",
    "pageIcon": "lucide:user",
    "sectionId": "customer",
    "fieldLabel": "pages.minisite.index.customer.tabName",
    "fieldInfo": "pages.minisite.index.customer.tabNameInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/customer",
    "pageTitle": "general.customer",
    "pageIcon": "lucide:user",
    "sectionId": "customer",
    "fieldLabel": "pages.minisite.index.customer.tabInformation",
    "fieldInfo": "pages.minisite.index.customer.tabInformationInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/customer",
    "pageTitle": "general.customer",
    "pageIcon": "lucide:user",
    "sectionId": "display",
    "fieldLabel": "pages.minisite.index.customer.showUpcomingAppointments",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/customer",
    "pageTitle": "general.customer",
    "pageIcon": "lucide:user",
    "sectionId": "display",
    "fieldLabel": "pages.minisite.index.customer.showPastAppointments",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/customer",
    "pageTitle": "general.customer",
    "pageIcon": "lucide:user",
    "sectionId": "display",
    "fieldLabel": "pages.minisite.index.customer.showSales",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/customer",
    "pageTitle": "general.customer",
    "pageIcon": "lucide:user",
    "sectionId": "display",
    "fieldLabel": "pages.minisite.index.customer.showGiftCards",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/customer",
    "pageTitle": "general.customer",
    "pageIcon": "lucide:user",
    "sectionId": "display",
    "fieldLabel": "pages.minisite.index.customer.showPasses",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/customer",
    "pageTitle": "general.customer",
    "pageIcon": "lucide:user",
    "sectionId": "display",
    "fieldLabel": "pages.minisite.index.customer.showBalances",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gallery",
    "pageTitle": "minisite.gallery",
    "pageIcon": "lucide:images",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/pages/gallery",
    "pageTitle": "minisite.gallery",
    "pageIcon": "lucide:images",
    "sectionId": "gallery",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.gallery.info",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gallery",
    "pageTitle": "minisite.gallery",
    "pageIcon": "lucide:images",
    "sectionId": "gallery",
    "fieldLabel": "pages.minisite.index.gallery.tabName",
    "fieldInfo": "pages.minisite.index.gallery.tabNameInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gallery",
    "pageTitle": "minisite.gallery",
    "pageIcon": "lucide:images",
    "sectionId": "gallery",
    "fieldLabel": "pages.minisite.index.gallery.tabInformation",
    "fieldInfo": "pages.minisite.index.gallery.tabInformationInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gallery",
    "pageTitle": "minisite.gallery",
    "pageIcon": "lucide:images",
    "sectionId": "images",
    "sectionLabel": "pages.minisite.index.gallery.images",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/pages/gallery",
    "pageTitle": "minisite.gallery",
    "pageIcon": "lucide:images",
    "sectionId": "images",
    "sectionLabel": "pages.minisite.index.gallery.images",
    "fieldLabel": "pages.minisite.index.gallery.images",
    "fieldInfo": "pages.minisite.index.gallery.imagesInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "giftCards",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.giftCards.info",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "giftCards",
    "fieldLabel": "pages.minisite.index.giftCards.tabName",
    "fieldInfo": "pages.minisite.index.giftCards.tabNameInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "giftCards",
    "fieldLabel": "pages.minisite.index.giftCards.tabInformation",
    "fieldInfo": "pages.minisite.index.giftCards.tabInformationInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "fieldLabel": "minisite.termsAgreement",
    "fieldInfo": "pages.minisite.index.giftCards.termsAgreement",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "fieldLabel": "minisite.termsTitle",
    "fieldInfo": "pages.minisite.index.giftCards.termsTitle",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "fieldLabel": "minisite.termsContent",
    "fieldInfo": "pages.minisite.index.giftCards.termsAndConditions",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "fieldLabel": "minisite.termsAccept",
    "fieldInfo": "minisite.termsAcceptInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "amounts",
    "fieldLabel": "general.expiryDays",
    "fieldInfo": "pages.minisite.index.giftCards.expiryDays",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "amounts",
    "fieldLabel": "pages.minisite.index.giftCards.presetAmounts",
    "fieldInfo": "pages.minisite.index.giftCards.presetAmountsInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "amounts",
    "fieldLabel": "pages.minisite.index.giftCards.customAmounts",
    "fieldInfo": "pages.minisite.index.giftCards.customAmountsInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "amounts",
    "fieldLabel": "pages.minisite.index.giftCards.customAmountLimit",
    "fieldInfo": "pages.minisite.index.giftCards.customAmountLimitInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/gift-cards",
    "pageTitle": "general.giftCards",
    "pageIcon": "lucide:gift",
    "sectionId": "image",
    "sectionLabel": "pages.minisite.index.giftCards.giftCardImage",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/pages",
    "pageTitle": "general.pages",
    "pageIcon": "lucide:layout-grid",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/pages/passes",
    "pageTitle": "general.passes",
    "pageIcon": "lucide:ticket",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/pages/passes",
    "pageTitle": "general.passes",
    "pageIcon": "lucide:ticket",
    "sectionId": "passes",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.passes.info",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/passes",
    "pageTitle": "general.passes",
    "pageIcon": "lucide:ticket",
    "sectionId": "passes",
    "fieldLabel": "pages.minisite.index.passes.tabName",
    "fieldInfo": "pages.minisite.index.passes.tabNameInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/passes",
    "pageTitle": "general.passes",
    "pageIcon": "lucide:ticket",
    "sectionId": "passes",
    "fieldLabel": "pages.minisite.index.passes.tabInformation",
    "fieldInfo": "pages.minisite.index.passes.tabInformationInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/passes",
    "pageTitle": "general.passes",
    "pageIcon": "lucide:ticket",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/pages/passes",
    "pageTitle": "general.passes",
    "pageIcon": "lucide:ticket",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "fieldLabel": "minisite.termsAgreement",
    "fieldInfo": "pages.minisite.index.passes.termsAgreement",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/passes",
    "pageTitle": "general.passes",
    "pageIcon": "lucide:ticket",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "fieldLabel": "minisite.termsTitle",
    "fieldInfo": "pages.minisite.index.passes.termsTitle",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/passes",
    "pageTitle": "general.passes",
    "pageIcon": "lucide:ticket",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "fieldLabel": "minisite.termsContent",
    "fieldInfo": "pages.minisite.index.passes.termsContent",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/passes",
    "pageTitle": "general.passes",
    "pageIcon": "lucide:ticket",
    "sectionId": "terms",
    "sectionLabel": "minisite.pages.terms",
    "fieldLabel": "minisite.termsAccept",
    "fieldInfo": "minisite.termsAcceptInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/passes",
    "pageTitle": "general.passes",
    "pageIcon": "lucide:ticket",
    "sectionId": "image",
    "sectionLabel": "pages.minisite.index.passes.passImage",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/pages/reviews",
    "pageTitle": "general.reviews",
    "pageIcon": "lucide:star",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/pages/reviews",
    "pageTitle": "general.reviews",
    "pageIcon": "lucide:star",
    "sectionId": "reviews",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.reviews.info",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/reviews",
    "pageTitle": "general.reviews",
    "pageIcon": "lucide:star",
    "sectionId": "reviews",
    "fieldLabel": "pages.minisite.index.reviews.tabName",
    "fieldInfo": "pages.minisite.index.reviews.tabNameInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/reviews",
    "pageTitle": "general.reviews",
    "pageIcon": "lucide:star",
    "sectionId": "reviews",
    "fieldLabel": "pages.minisite.index.reviews.showService",
    "fieldInfo": "pages.minisite.index.reviews.showServiceInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/pages/reviews",
    "pageTitle": "general.reviews",
    "pageIcon": "lucide:star",
    "sectionId": "reviews",
    "fieldLabel": "pages.minisite.index.reviews.showReplies",
    "fieldInfo": "pages.minisite.index.reviews.showRepliesInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "sectionId": "general",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.payments.enable",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "sectionId": "deposit",
    "sectionLabel": "general.deposit",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "sectionId": "deposit",
    "sectionLabel": "general.deposit",
    "fieldLabel": "pages.minisite.index.payments.depositAmount",
    "fieldInfo": "pages.minisite.index.payments.depositAmountInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "sectionId": "deposit",
    "sectionLabel": "general.deposit",
    "fieldLabel": "pages.minisite.index.payments.payInFull",
    "fieldInfo": "pages.minisite.index.payments.payInFullInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "sectionId": "deposit",
    "sectionLabel": "general.deposit",
    "fieldLabel": "pages.minisite.index.payments.payLater",
    "fieldInfo": "pages.minisite.index.payments.payLaterInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "sectionId": "deposit",
    "sectionLabel": "general.deposit",
    "fieldLabel": "pages.minisite.index.payments.depositPolicy",
    "fieldInfo": "pages.minisite.index.payments.depositPolicyInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "sectionId": "cardCapture",
    "sectionLabel": "pages.minisite.index.payments.cardCapture",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "sectionId": "cardCapture",
    "sectionLabel": "pages.minisite.index.payments.cardCapture",
    "fieldLabel": "pages.minisite.index.payments.enableCardCapture",
    "fieldInfo": "pages.minisite.index.payments.enableCardCaptureInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "sectionId": "cardCapture",
    "sectionLabel": "pages.minisite.index.payments.cardCapture",
    "fieldLabel": "pages.minisite.index.payments.cardCapturePolicy",
    "fieldInfo": "pages.minisite.index.payments.cardCapturePolicyInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "sectionId": "reminders",
    "sectionLabel": "general.reminders",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "sectionId": "reminders",
    "sectionLabel": "general.reminders",
    "fieldLabel": "pages.minisite.index.payments.paymentReminder",
    "fieldInfo": "pages.minisite.index.payments.paymentReminderInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/payments",
    "pageTitle": "general.payments",
    "pageIcon": "lucide:credit-card",
    "sectionId": "processors",
    "sectionLabel": "components.minisite.elements.menu.payments.processorOrder.title",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "share",
    "sectionLabel": "minisite.pages.share",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "features",
    "sectionLabel": "manage.landings.onlineBooking.tabsLabel",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "features",
    "sectionLabel": "manage.landings.onlineBooking.tabsLabel",
    "fieldLabel": "general.onlineBooking",
    "fieldInfo": "minisite.onlineBookingInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "features",
    "sectionLabel": "manage.landings.onlineBooking.tabsLabel",
    "fieldLabel": "general.timetable",
    "fieldInfo": "minisite.timetableInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "features",
    "sectionLabel": "manage.landings.onlineBooking.tabsLabel",
    "fieldLabel": "minisite.lastMinute",
    "fieldInfo": "minisite.lastMinuteInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "general",
    "fieldLabel": "pages.minisite.index.preferences.ovatuYou",
    "fieldInfo": "pages.minisite.index.preferences.ovatuYouInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "general",
    "fieldLabel": "pages.minisite.index.preferences.servicePrices",
    "fieldInfo": "pages.minisite.index.preferences.servicePricesInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "general",
    "fieldLabel": "pages.minisite.index.preferences.onlineAppointments",
    "fieldInfo": "pages.minisite.index.preferences.onlineAppointmentsInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "customers",
    "sectionLabel": "general.customers",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "customers",
    "sectionLabel": "general.customers",
    "fieldLabel": "pages.minisite.index.preferences.forCustomers",
    "fieldInfo": "pages.minisite.index.preferences.forCustomersInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "customers",
    "sectionLabel": "general.customers",
    "fieldLabel": "pages.minisite.index.preferences.newRegistrations",
    "fieldInfo": "pages.minisite.index.preferences.newRegistrationsInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "availability",
    "sectionLabel": "general.availability",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "availability",
    "sectionLabel": "general.availability",
    "fieldLabel": "pages.minisite.index.preferences.bookingThreshold",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "availability",
    "sectionLabel": "general.availability",
    "fieldLabel": "pages.minisite.index.preferences.bookingFutureLimit",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "availability",
    "sectionLabel": "general.availability",
    "fieldLabel": "pages.minisite.index.preferences.waitTime",
    "fieldInfo": "pages.minisite.index.preferences.waitTimeInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "serviceSelection",
    "sectionLabel": "pages.minisite.index.preferences.serviceSelection",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "serviceSelection",
    "sectionLabel": "pages.minisite.index.preferences.serviceSelection",
    "fieldLabel": "pages.minisite.index.preferences.employeeSelection",
    "fieldInfo": "pages.minisite.index.preferences.employeeSelectionInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "serviceSelection",
    "sectionLabel": "pages.minisite.index.preferences.serviceSelection",
    "fieldLabel": "pages.minisite.index.preferences.firstAvailable",
    "fieldInfo": "pages.minisite.index.preferences.firstAvailableInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "serviceSelection",
    "sectionLabel": "pages.minisite.index.preferences.serviceSelection",
    "fieldLabel": "pages.minisite.index.preferences.multiService",
    "fieldInfo": "pages.minisite.index.preferences.multiServiceInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "analytics",
    "sectionLabel": "pages.minisite.index.preferences.analyticsConversionCode",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "analytics",
    "sectionLabel": "pages.minisite.index.preferences.analyticsConversionCode",
    "fieldLabel": "pages.minisite.index.preferences.analyticsConversionCode",
    "fieldInfo": "pages.minisite.index.preferences.analyticsConversionCodeInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "waitlist",
    "sectionLabel": "general.waitlist",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "waitlist",
    "sectionLabel": "general.waitlist",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.preferences.waitlist",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "waitlist",
    "sectionLabel": "general.waitlist",
    "fieldLabel": "pages.minisite.index.preferences.waitlistNotificationMode",
    "fieldInfo": "pages.minisite.index.preferences.waitlistNotificationModeInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "selfCancel",
    "sectionLabel": "pages.minisite.index.preferences.customerSelfCancel",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "selfCancel",
    "sectionLabel": "pages.minisite.index.preferences.customerSelfCancel",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.preferences.customerSelfCancelInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "selfCancel",
    "sectionLabel": "pages.minisite.index.preferences.customerSelfCancel",
    "fieldLabel": "pages.minisite.index.preferences.selfCancelWindow",
    "fieldInfo": "pages.minisite.index.preferences.selfCancelWindowInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "selfCancel",
    "sectionLabel": "pages.minisite.index.preferences.customerSelfCancel",
    "fieldLabel": "pages.minisite.index.preferences.selfCancelNotice",
    "fieldInfo": "pages.minisite.index.preferences.selfCancelNoticeInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "selfMove",
    "sectionLabel": "pages.minisite.index.preferences.customerSelfMove",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "selfMove",
    "sectionLabel": "pages.minisite.index.preferences.customerSelfMove",
    "fieldLabel": "general.enabled",
    "fieldInfo": "pages.minisite.index.preferences.customerSelfMoveInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/preferences",
    "pageTitle": "general.preferences",
    "pageIcon": "lucide:settings",
    "sectionId": "selfMove",
    "sectionLabel": "pages.minisite.index.preferences.customerSelfMove",
    "fieldLabel": "pages.minisite.index.preferences.selfMoveWindow",
    "fieldInfo": "pages.minisite.index.preferences.selfMoveWindowInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/site-notice",
    "pageTitle": "minisite.siteNotice",
    "pageIcon": "lucide:alert-triangle",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/site-notice",
    "pageTitle": "minisite.siteNotice",
    "pageIcon": "lucide:alert-triangle",
    "sectionId": "notice",
    "fieldLabel": "general.enabled",
    "fieldInfo": "minisite.siteNoticeInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/site-notice",
    "pageTitle": "minisite.siteNotice",
    "pageIcon": "lucide:alert-triangle",
    "sectionId": "notice",
    "fieldLabel": "minisite.noticeContent",
    "fieldInfo": "minisite.noticeContentInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "kind": "page"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "customerConsent",
    "sectionLabel": "manage.landings.termsAndPolicy.customerConsentLabel",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "customerConsent",
    "sectionLabel": "manage.landings.termsAndPolicy.customerConsentLabel",
    "fieldLabel": "manage.landings.termsAndPolicy.consentEnabledLabel",
    "fieldInfo": "pages.account.index.privacy.info",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "customerConsent",
    "sectionLabel": "manage.landings.termsAndPolicy.customerConsentLabel",
    "fieldLabel": "general.title",
    "fieldInfo": "pages.account.index.privacy.titleInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "customerConsent",
    "sectionLabel": "manage.landings.termsAndPolicy.customerConsentLabel",
    "fieldLabel": "pages.account.index.privacy.content",
    "fieldInfo": "pages.account.index.privacy.contentInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "customerConsent",
    "sectionLabel": "manage.landings.termsAndPolicy.customerConsentLabel",
    "fieldLabel": "general.acceptLabel",
    "fieldInfo": "pages.account.index.privacy.acceptLabelInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "marketingConsent",
    "sectionLabel": "manage.landings.termsAndPolicy.marketingConsentLabel",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "marketingConsent",
    "sectionLabel": "manage.landings.termsAndPolicy.marketingConsentLabel",
    "fieldLabel": "manage.landings.termsAndPolicy.consentEnabledLabel",
    "fieldInfo": "pages.account.index.privacy.marketingConsentInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "marketingConsent",
    "sectionLabel": "manage.landings.termsAndPolicy.marketingConsentLabel",
    "fieldLabel": "general.title",
    "fieldInfo": "pages.account.index.privacy.marketingConsentTitleInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "marketingConsent",
    "sectionLabel": "manage.landings.termsAndPolicy.marketingConsentLabel",
    "fieldLabel": "pages.account.index.privacy.marketingConsentContent",
    "fieldInfo": "pages.account.index.privacy.marketingConsentContentInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "marketingConsent",
    "sectionLabel": "manage.landings.termsAndPolicy.marketingConsentLabel",
    "fieldLabel": "general.acceptLabel",
    "fieldInfo": "pages.account.index.privacy.marketingConsentAcceptLabelInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "bookingTerms",
    "sectionLabel": "manage.landings.termsAndPolicy.bookingTermsLabel",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "bookingTerms",
    "sectionLabel": "manage.landings.termsAndPolicy.bookingTermsLabel",
    "fieldLabel": "manage.landings.termsAndPolicy.termsRequiredLabel",
    "fieldInfo": "pages.minisite.index.terms.info",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "bookingTerms",
    "sectionLabel": "manage.landings.termsAndPolicy.bookingTermsLabel",
    "fieldLabel": "general.title",
    "fieldInfo": "pages.minisite.index.terms.titleInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "bookingTerms",
    "sectionLabel": "manage.landings.termsAndPolicy.bookingTermsLabel",
    "fieldLabel": "pages.minisite.index.terms.bookingTerms",
    "fieldInfo": "pages.minisite.index.terms.bookingTermsInfo",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "bookingTerms",
    "sectionLabel": "manage.landings.termsAndPolicy.bookingTermsLabel",
    "fieldLabel": "general.acceptLabel",
    "fieldInfo": "pages.minisite.index.terms.acceptLabel",
    "kind": "field"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "cookie",
    "sectionLabel": "manage.landings.termsAndPolicy.cookieLabel",
    "kind": "section"
  },
  {
    "pagePath": "/minisite/terms-and-policy",
    "pageTitle": "manage.pages.termsAndPolicy",
    "pageIcon": "lucide:scroll-text",
    "sectionId": "cookie",
    "sectionLabel": "manage.landings.termsAndPolicy.cookieLabel",
    "fieldLabel": "pages.account.index.privacy.euCookieLaw",
    "fieldInfo": "pages.account.index.privacy.euCookieLawInfo",
    "kind": "field"
  }
]
